var _path, _linearGradient, _path2, _linearGradient2, _path3, _path4, _path5, _linearGradient3, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8HandPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#64717c",
    d: "M29,22c-0.552,0-1,0.448-1,1v1h-2v-2h-6v10h6v-6h2v1c0,0.552,0.448,1,1,1s1-0.448,1-1v-4 C30,22.448,29.552,22,29,22z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "btOUNjJFmyqHogjNvSUn2a",
    x1: 6.933,
    x2: 7.128,
    y1: 16.808,
    y2: 26.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fec52b"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#btOUNjJFmyqHogjNvSUn2a)",
    d: "M11.212,22.675c0.076-0.13,0.148-0.258,0.23-0.393l0.014-0.056 C11.792,21.553,12,20.804,12,20c0-2.761-2.239-5-5-5s-5,2.239-5,5c0,0.786,0.198,1.52,0.521,2.182l0.016,0.068 c0.104,0.171,0.197,0.335,0.292,0.5c0.011,0.017,0.02,0.036,0.031,0.054c1,1.752,1.48,3.249,1.48,6.197 c0,1.802-0.582,3.499-1.001,5h7.321c-0.419-1.501-1.022-3.198-1.022-5c0-2.957,0.484-4.428,1.49-6.183 C11.159,22.771,11.182,22.721,11.212,22.675z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "btOUNjJFmyqHogjNvSUn2b",
    x1: 38.503,
    x2: 38.501,
    y1: 11.808,
    y2: 24.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fec52b"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#btOUNjJFmyqHogjNvSUn2b)",
    d: "M47,36v-1c0-6-2.918-9.378-4.64-11.96l-1.965-2.948c-0.789-1.184-0.542-2.775,0.569-3.664 l1.145-0.916c1.054-0.843,1.248-2.371,0.438-3.45v0c-0.846-1.128-2.458-1.333-3.56-0.452l-4.227,3.382 c-2.095,1.676-2.481,4.713-0.871,6.859l1.688,2.25c0.924,1.232,1.423,2.73,1.423,4.27v0C37,30.928,34.928,33,32.372,33H30v3H47z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#c0c9cc",
    d: "M30.149,12.683L30.149,12.683c-0.71-0.428-1.631-0.199-2.059,0.51L17.766,30.323 c-0.428,0.71-0.199,1.631,0.51,2.059h0c0.71,0.428,1.631,0.199,2.059-0.51L30.66,14.742C31.087,14.032,30.859,13.111,30.149,12.683 z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#64717c",
    d: "M24.219,19.617l-2.286-1.378c-0.629-0.379-1.447-0.177-1.826,0.453l-6.54,10.851l3.426,2.065 L24.219,19.617z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "btOUNjJFmyqHogjNvSUn2c",
    x1: 23.82,
    x2: 24.044,
    y1: 30.15,
    y2: 43.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1aab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f979e"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#btOUNjJFmyqHogjNvSUn2c)",
    d: "M44.532,33.176L25.45,28.641c-4.502-1.07-9.22-0.768-13.549,0.866l-8.983,3.391 C1.162,33.561,0,35.242,0,37.119V44h48v-6.435C48,35.475,46.565,33.659,44.532,33.176z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8HandPlane);
export default __webpack_public_path__ + "static/media/icons8-hand-plane.a8b85f8a747a62e241b6ea7c604eef85.svg";
export { ForwardRef as ReactComponent };